import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "31",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"15.251\" cy=\"15.252\" r=\"11\" fill=\"#fff\" stroke=\"#1F74D7\" stroke-width=\"2\" transform=\"rotate(-18.986 15.251 15.252)\"></circle><g clip-path=\"url(#a)\"><path fill=\"#1F74D7\" stroke=\"#1F74D7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m10.238 16.816 7.598-7.424-1.177 10.558-2.27-3.494z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"m5.356 12.31 14.752-5.075 5.075 14.752-14.752 5.075z\"></path></clipPath></defs>", 3)
  ])))
}
export default { render: render }